module.exports = __webpack_public_path__ + "files/cd5bcb9caeaaf2b66d10c73d18a36cac.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-6.png
// module id = 1488
// module chunks = 60